/* eslint-disable filenames/match-regex */
import { useMemo } from "react";

import {
  getTranslationMessages,
  useLingui
} from "@base/common/libs/i18n/index.js";

export const useI18n = () => {
  const { _ } = useLingui();

  const translationMessages = useMemo(
    function updateTranslationMessages() {
      return getTranslationMessages();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_]
  );

  return { translationMessages };
};
